exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-51c8401e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:2px;background:#000}.col[data-v-51c8401e]{-webkit-box-flex:1;-ms-flex:1;flex:1}.col+.col[data-v-51c8401e]{margin-left:2px}", ""]);

// exports
